import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';
import { instantSavings, rapidKey, mfa } from '@mgo/core';
import vuexTimeBomb from '@mgo/vuex-time-bomb';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    devNull: {},
    config: {},
    loading: false,
    highIntent: false,
    dcoa: false,
    billingAddressType: '',
    businessName: '',
    businessAlias1: '',
    businessAlias2: '',
    businessAlias3: '',
    businessAlias4: '',
    informedDelivery: false,
    forwardType: '',
    moverType: '',
    startDate: '',
    stopDate: '',

    // mover
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    email: '',
    phoneNumber: '',
    phoneType: 'MOBILE',
    moverUUID: '',

    // address
    oldStreetAddress: '',
    oldCity: '',
    oldState: '',
    oldZipCode: '',
    oldUrbanizationName: '',
    oldPoBoxNumber: '',
    oldAddressUUID: '',
    newStreetAddress: '',
    newCity: '',
    newState: '',
    newZipCode: '',
    newUrbanizationName: '',
    newPoBoxNumber: '',
    newPrivateMailbox: '',
    newAddressUUID: '',
    recentConstruction: false,
    overrideAms: false,

    // coaCheck modal
    coaCheckModal: false,
  },
  mutations: {
    CHOICE_MOVE_COMBINED(state, payload) {
      Object.assign(state, payload);
    },
    DEV_NULL({ devNull }, { message }) {
      Object.assign(devNull, message);
    },
    SET_CONFIG(state, config) {
      Object.assign(state, { config });
    },
    SET_HIGH_INTENT(state) {
      Object.assign(state, { highIntent: true });
    },
    ENABLE_LOADER(state) {
      Object.assign(state, { loading: true });
    },
    DISABLE_LOADER(state) {
      Object.assign(state, { loading: false });
    },
  },
  actions: {
    async setChoiceData(context, payload) {
      context.commit('CHOICE_MOVE_COMBINED', payload);
    },
    async setDevNull({ commit }, error) {
      commit('DEV_NULL', error);
    },
  },
  getters: {
    mgoAppName: ({ config: { mgoAppName } }) => mgoAppName ?? 'mgo',
    icoaAmount: ({ config: { icoaAmount } }) => icoaAmount ?? 105,
    flagOutageBanner: ({ config: { showGpOutageBanner } }) => showGpOutageBanner ?? false,
    flagAccessHandoffEnabled: ({ config }) => config?.accessHandoffEnabled ?? false,
    flagAmpersendEnabled: ({ config: { ampersendEnabled } }) => ampersendEnabled ?? false,
    flagBizBillingAddressEnabled: ({ config }) => config?.bizBillingAddressEnabled ?? false,
    flagBusinessAliasEnabled: ({ config: { bizAliasEnabled } }) => bizAliasEnabled ?? false,
    flagEMFEnabled: ({ config: { mgoExtendedFwdEnabled } }) => mgoExtendedFwdEnabled ?? false,
    upcomingMaintenance: ({ config: { upcomingMaintenance } }) => upcomingMaintenance ?? '',
    bizCostComputationEnabled:
    ({ config: { bizCostComputationEnabled } }) => bizCostComputationEnabled ?? false,
    enhancedBusinessAliasesEnabled:
    ({ config: { enhancedBusinessAliasesEnabled } }) => enhancedBusinessAliasesEnabled ?? false,
    enhancedBusinessFlowEnabled: ({
      config: { enhancedBusinessFlowEnabled },
    }) => enhancedBusinessFlowEnabled ?? false,
    enhancedBusinessAliasesInitialCount:
    ({
      config:
      { enhancedBusinessAliasesInitialCount },
    }) => enhancedBusinessAliasesInitialCount ?? 4,
    enhancedBusinessAliasesIncrementCount:
    ({
      config:
      { enhancedBusinessAliasesIncrementCount },
    }) => enhancedBusinessAliasesIncrementCount ?? 1,
    enhancedBusinessAliasesMaxCount:
    ({ config: { enhancedBusinessAliasesMaxCount } }) => enhancedBusinessAliasesMaxCount ?? 4,
  },
  modules: {
    instantSavings: instantSavings({
      MGO_API: '/api/mgo',
      clientId: 'mgo-app',
    }),
    rapidKey: rapidKey({
      MGO_API: '/api/mgo',
    }),
    mfa: mfa({
      MGO_API: '/api/mgo',
    }),
  },
  plugins: [
    pathify.plugin,
    vuexTimeBomb.plugin,
  ],
});
